import React from "react";
import { StatusTags } from "MODULES/shared/components";
import AccountingHold from "./AccountingHold";
import QCHold from "./QCHold";
import UnderReview from "./UnderReview";
import Cancelled from "./Cancelled";

export default function Warnings() {
  return (
    <StatusTags>
      <AccountingHold />
      <Cancelled />
      <QCHold />
      <UnderReview />
    </StatusTags>
  );
}



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Warnings/Warnings.jsx